// Helper function to get next step key
export const getNextStepKey = (currentStepKey: string): string | undefined => {
  const stepOrder = [
    'hotel-location',
    'your-details',
    'hotel-operations',
    'certifications',
    'planet',
    'people',
    'policy',
    'sources',
  ];
  const currentIndex = stepOrder.indexOf(currentStepKey);
  return currentIndex < stepOrder.length - 1
    ? stepOrder[currentIndex + 1]
    : undefined;
};
